export const EXAM_SECTIONS = ['SAT', 'ACT', 'EST I', 'EST II'] as const;
export type ExamSection = (typeof EXAM_SECTIONS)[number];

/**
 * `Requested` and `Approved` (2026-07) implement the exam approval workflow: a sales role sets a
 * section `Requested`, every Admin is notified, an Admin sets it `Approved` (or rejects it back to
 * `Not Booked`), and only then can the section be `Booked` (finance recognition is unchanged — it
 * still happens at `Booked`). Admin / Exam Coordinator may still book directly, bypassing the gate.
 */
export const BOOKING_STATUSES = [
  'Not Booked',
  'Requested',
  'Approved',
  'Booked',
  'Completed',
  'Cancelled',
] as const;
export type BookingStatus = (typeof BOOKING_STATUSES)[number];
